/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react"

import NavUserInfoImage from "./NavUserInfoImage"
import { getData } from "../../../../../assets/shared/api/ApiCalls"
import AllTextState from "../../../../../assets/shared/state/AllTextState"
import { ConfigContext } from "../../../../../contexts/ConfigContext"
import {
  IUserInformation,
  IUserPermission
} from "../../../../../assets/js/features/user/state/UserTypes"
import {
  getCurrentUserOrgId,
  getUserInfo,
  getUserPermission,
  getUserRole,
  setUserInformation
} from "../../../../../assets/js/app/state/appSessionStorage"
import {
  fileTypes,
  IFile
} from "../../../../../assets/shared/components/download/fileTypes"
import { axiosPrivate } from "../../../../../api/axios"
import { Skeleton } from "@mui/material"

const NavUserInfo = (): JSX.Element => {
  const [data, setData] = useState<any>()
  const [userInfo, setUserInfo] = useState<IUserInformation>()
  const [currentImage, setCurrentImage] = useState<IFile | null>()
  const [isOgImageLoading, setIsOrgImageLoading] = useState<boolean>(false)

  const userPermission: IUserPermission = getUserPermission()
  const userInformation: IUserInformation = getUserInfo()

  const configContext: any = useContext(ConfigContext)
  const { collapseMenu } = configContext.state

  useEffect(() => {
    const getUserPermission = () => {
      if (!userPermission) {
        getData("rest/get_user_permissions", setData)
      } else {
        setData(userPermission)
      }
    }

    const getUserInformation = () => {
      if (!userInformation) {
        getData("rest/get_user_info", setUserInfo)
      } else {
        setUserInfo({ ...userInformation,
          userId: userPermission.userId })
      }
    }

    getUserInformation()
    getUserPermission()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if(userInformation)
      setUserInfo(userInformation)
  }, [userInformation?.currentTenantName])

  useEffect(() => {
    if(userInformation)
      setUserInfo(userInformation)
  }, [userInformation?.currentOrgName])

  const allowedUserRoles = [ //user who belong to org to-do: change const name
    "claim_manager",
    "org_admin",
    "claimant",
    "rehab_manager",
    "employer"
  ]
  const checkForUserRole = allowedUserRoles.includes(getUserRole())

  useEffect(() => {
    if (userInfo) {
      setUserInformation(userInfo)
      const downloadIcon = () => {
        setIsOrgImageLoading(true)
        axiosPrivate
          .post("rest/get_organization_logo", { orgId: getCurrentUserOrgId() })
          .then((response) => {
            setCurrentImage(response.data)
            setIsOrgImageLoading(false)
          })
          .catch((error) => {
            setCurrentImage(null)
            setIsOrgImageLoading(false)
            console.error(error)
          })
      }
      if(checkForUserRole) downloadIcon()
    }
  }, [userInfo])

  const renderName = () => {
    if (!userInfo) return null

    return (
      <div style={{ color: "#1856b4",
        fontWeight: 600 }}>
        <span>{userInfo.firstName} </span>
        <span>{userInfo.lastName}</span>
      </div>
    )
  }

  const renderUserRole = () => {
    if (!data) return null
    return (
      <div style={{ color: "#000",
        fontSize: "10px" }}>
        Title: {userInformation?.professionalTitle}
      </div>
    )
  }

  const renderOrgName = () => {
    if (!userInfo || !checkForUserRole) return null
    return (
      <div style={{ color: "#000",
        fontSize: "10px" }}>
        {AllTextState.organization}: {userInfo.currentOrgName}
      </div>
    )
  }

  const renderTenantName = () => {
    if (!userInfo || getUserRole() !== "tenant_admin") return null

    return (
      <div style={{ color: "#000",
        fontSize: "10px" }}>
        Tenant: {userInfo.currentTenantName}
      </div>
    )
  }
  const renderOrgImage = () => {
    const renderFileImage = () => {
      if(isOgImageLoading) return <Skeleton style={{ width: "50px",
        height: "50px" }} />
      if (!currentImage) return null

      const fileExtension = currentImage.fileName.split(".")[1]
      const fileMimeType = fileTypes[fileExtension.toLowerCase()]

      const fileTypeName = fileMimeType?.split("/")[0]
        ? fileMimeType?.split("/")[0]
        : "image"

      if (fileTypeName === "image")
        return (
          <img
            src={`data:${fileMimeType};base64,${currentImage.fileContent}`}
            alt="User-Profile"
            style={{
              maxWidth: "100%",
              height: "auto"
            }}
          />
        )
    }

    if (!checkForUserRole) return null
    if (currentImage?.status === "ERROR") return null
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ width: "40px" }}
      >
        {renderFileImage()}
      </div>
    )
  }

  const renderContent = () => {
    if (collapseMenu) return <></>
    return (
      <>
        {renderName()}
        {renderUserRole()}
        {renderOrgName()}
        {renderTenantName()}
        {renderOrgImage()}
      </>
    )
  }
  return (
    <>
      <div className="user-info-container">
        <div style={{marginBottom: "10px"}}><NavUserInfoImage /></div>
        {renderContent()}
      </div>
    </>
  )
}

export default NavUserInfo
